module.exports = __webpack_public_path__ + "img/file.4b2af15e.svg";